import moment from 'moment';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

const DatesPicker = ({
    btn = "OK",
    onOk = () => {},
    onChange = () => {}
}) => {

    const [date1, setDate1] = useState(new Date())
    const [date2, setDate2] = useState(new Date())
    const [date_error, set_date_error] = useState(false)

    function localOk() {

        if(date1.getTime() >= date2.getTime()) {

            set_date_error(true)

            return
        }


        onOk(date1, date2)
    }

    useEffect(() => {
        if(!date_error) {
            setTimeout(
                () => set_date_error(false),
                5000
            )
        }
    }, [date_error])

    return (
        <>
            <section className='container'>
                <div className='row'>


                    <div class="col-12 col-md-6 col-lg-6">
                        <div className='form-group'>
                            <label>Fecha de inicio</label>
                            <input value={moment(date1).add(1, "d").format("YYYY-MM-DD")} onChange={({target}) => setDate1(target.valueAsDate)} type='date' className='form-control' />
                        </div>
                    </div>

                    <div class="col-12 col-md-6 col-lg-6">
                        <div className='form-group'>
                            <label>Fecha de fin</label>
                            <input value={moment(date2).add(1, "d").format("YYYY-MM-DD")} onChange={({target}) => setDate2(target.valueAsDate)} type='date' className='form-control' />
                        </div>
                    </div>


                    

                </div>

                { date_error &&

                    <div className="alert alert-warning" role="alert">
                        La fecha de inicio no pude ser mayor que la de fin
                    </div>

                }

                <button 
                    style={{
                        width: "fit-content",
                        minWidth: "10rem"
                    }}
                    className='btn-deg mt-3' onClick={localOk}
                >
                    {btn}

                </button>
            </section>  
        </>
    );
};

export default DatesPicker;